import { PropsWithChildren, ReactNode, useState } from 'react';
import { cx } from '@linaria/atomic';
import { Text } from '@frontend/design-system';
import { SubtitleStyles } from './subtitle.styles';

export type SubtitleProps = PropsWithChildren<{ subtitle?: string | ReactNode; moreSubtitle?: string }>;

export function Subtitle({ subtitle, moreSubtitle }: SubtitleProps) {
  return (
    <Text className={SubtitleStyles.subtitleTextStyle3}>
      {typeof subtitle === 'string' ? (
        <ExpandText
          className={SubtitleStyles.subtitleExpandTextStyle4}
          text={subtitle || ''}
          hiddenText={moreSubtitle}
        />
      ) : (
        subtitle
      )}
    </Text>
  );
}

interface ExpandTextProps {
  actionText?: string;
  className?: string;
  text: string | React.ReactNode;
  hiddenText?: string;
}

const mainStyles = SubtitleStyles.mainStyles;
const expandStyles = SubtitleStyles.expandStyles;

export const ExpandText = ({ className, text, hiddenText }: ExpandTextProps) => {
  const [showHiddenText, setShowHiddenText] = useState(false);

  return (
    <span className={cx(mainStyles, className)}>
      {text}
      {!showHiddenText && hiddenText && (
        <span
          className={expandStyles}
          onClick={() => setShowHiddenText(true)}
          data-trackingid='nav-portal-sharedpageheader-btn-more'
        >
          {' '}
          more...
        </span>
      )}
      {showHiddenText && (
        <>
          {hiddenText}
          <span
            className={expandStyles}
            onClick={() => setShowHiddenText(false)}
            data-trackingid='nav-portal-sharedpageheader-btn-less'
          >
            {' '}
            ...less
          </span>
        </>
      )}
    </span>
  );
};
